import { render, staticRenderFns } from "./BoxChartMetric.vue?vue&type=template&id=49bcba70"
import script from "./BoxChartMetric.vue?vue&type=script&lang=js"
export * from "./BoxChartMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports